import { Pipe, PipeTransform } from '@angular/core';
import { toZoned } from 'src/lib/utilities/temporal';

@Pipe({
	name: 'temporalZonedMap',
})
export class TemporalZonedMapPipe implements PipeTransform {
	transform(
		value: Temporal.ZonedDateTime | Temporal.Instant | Date,
		timezone?: string,
	): Temporal.ZonedDateTime {
		if (value == null) return null;
		timezone = timezone ?? Temporal.Now.timeZoneId();

		let zdt: Temporal.ZonedDateTime;
		if (value instanceof Temporal.ZonedDateTime) {
			zdt = value.withTimeZone(timezone);
		} else if (value instanceof Temporal.Instant) {
			zdt = value.toZonedDateTimeISO(timezone);
		} else {
			zdt = toZoned(value, timezone);
		}

		if (zdt.epochMilliseconds > 0) return zdt;
		else return null;
	}
}
